const pricing = [
  {
    id: 1,
    title: 'Basic Package',
    price: 500,
    unit: '/room',
    features: [
      'Interior Design Consultation',
      'Space Planning',
      'Color and Material Selection',
      '2D Floor Plans',
      'Mood Board Presentation',
    ],
  },
  {
    id: 2,
    title: 'Premium Package',
    price: 1000,
    unit: '/room',
    features: [
      'Interior Design Consultation',
      'Space Planning',
      'Color and Material Selection',
      '3D Renderings',
      'In-Person Site Visits',
    ],
  },
  {
    id: 3,
    title: 'Deluxe Package',
    price: 1500,
    unit: '/room',
    features: [
      'Interior Design Consultation',
      'Space Planning',
      'Color and Material Selection',
      'Custom Furniture Design',
      'Project Management',
    ],
  },
];

export default pricing;